
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { config } from 'environments/config';
import { SgfDescuento } from 'app/main/_model/descuentos/sgf-descuento';

@Injectable({
  providedIn: 'root'
})
export class DescuentoService {

constructor(
  private http: HttpClient,
) { }


filterDesc(token, hasta) {
  const params = new HttpParams()
      .set('token', token)
      .set("fec_corte", hasta);
  return this.http.post<any>(`${config.apiUrl}/socio/descuentos`, params)
      .toPromise()
      .then(res => <SgfDescuento[]>res.data)
      .then(data => {
          return data;
      });
}

}
